import { useCallback, useEffect, useRef, useState } from 'react';
import { logger } from '@digiwedge/logger';
import { useLocation } from '../providers/index.js';
import { getFallbackLocation } from '../utils/getFallbackLocation.js';
import { getGeoIpLocation } from '../utils/getGeoIpLocation.js';
export const useFetchLocation = () => {
    const { coords, setApproximateCoords } = useLocation();
    const [error, setError] = useState(false);
    const controllerRef = useRef(null);
    const latestOriginRef = useRef(coords?.origin ?? null);
    useEffect(() => {
        latestOriginRef.current = coords?.origin ?? null;
    }, [coords?.origin]);
    const fetchLocation = useCallback(() => {
        if (latestOriginRef.current === 'browser') {
            return;
        }
        try {
            controllerRef.current?.abort();
        }
        catch (err) {
            logger.error('Error aborting previous location fetch', { err });
        }
        const controller = new AbortController();
        controllerRef.current = controller;
        setError(false);
        getGeoIpLocation(controller.signal)
            .then((coords) => {
            if (!controller.signal.aborted && latestOriginRef.current !== 'browser') {
                setApproximateCoords(coords);
            }
        })
            .catch((err) => {
            if (!controller.signal.aborted && latestOriginRef.current !== 'browser') {
                logger.error('Failed to determine location', err);
                setApproximateCoords(getFallbackLocation());
                setError(true);
            }
        });
    }, [setApproximateCoords]);
    useEffect(() => {
        fetchLocation();
        return () => controllerRef.current?.abort();
    }, [fetchLocation]);
    return {
        error,
        retry: () => {
            fetchLocation();
        },
    };
};
//# sourceMappingURL=useFetchLocation.js.map